import { memo } from 'react';

import { useTableContext } from 'lib/context/TableContext/TableContext';
import { ia } from 'lib/helpers/utility';

import AGTable from 'components/shared/AGTable/AGTable';
import TableFilters from 'components/shared/AgTablePage/components/TableFilters';
import ViewTabs from 'components/shared/AgTablePage/components/ViewTabs';
import Header from 'components/shared/Header/Header';
import Pagination from 'components/shared/Pagination/Pagination';
import Popover from 'components/shared/Popovers/Popover/Popover';
import TableCounter from 'components/shared/Table/TableCounter';

import { GRID_OPTIONS } from '../lib/ordersHelper';

const category = 'orders_table';

const OrdersTableComponent = ({
  data,
  count,
  loading,
  showHeader = false,
  showFooter = false,
  rowClickHandler
}) => {
  const {
    limit,
    page,
    setPage,
    filters,
    setFilters,
    selectedRows,
    defaultFilters,
    initialFilters,
    setInitialFilters,
    isEditingFilter,
    setIsEditingFilter
  } = useTableContext();

  const changePageHandler = ({ selected }) => {
    setPage(selected + 1);
  };

  const cellClickHandler = async (e) => {
    if (['actions', '0'].includes(e?.column?.colId)) return;
    rowClickHandler(e);
  };

  return (
    <>
      {showHeader && (
        <Header title="Orders">
          <ViewTabs
            category="Orders"
            filters={filters}
            setFilters={setFilters}
            defaultFilters={defaultFilters}
            setInitialFilters={setInitialFilters}
            setIsEditingFilter={setIsEditingFilter}
          />
          <div className="flex  items-center gap-2">
            {ia(selectedRows) && selectedRows.length > 0 && (
              <Popover
                className="flex flex-1 justify-center self-center"
                buttonClassName="!bg-primary-700"
                position="left"
                isFixed
                options={[]}
              />
            )}
          </div>
        </Header>
      )}
      <div className="flex h-full flex-col overflow-hidden">
        {showHeader && (
          <TableFilters
            filters={filters}
            initialFilters={initialFilters}
            setFilters={setFilters}
            category={category}
            defaultFilters={defaultFilters}
            isEditingFilter={isEditingFilter}
            setIsEditingFilter={setIsEditingFilter}
          />
        )}
        <AGTable
          data={data}
          loading={loading}
          defaultFilters={defaultFilters}
          onCellClicked={cellClickHandler}
          rowClass="cursor-pointer"
          gridOptions={GRID_OPTIONS}
        />
        {showFooter && (
          <div className="flex items-center justify-between px-3">
            <TableCounter page={page} limit={limit} count={count} />
            <Pagination
              onPageChange={changePageHandler}
              totalItems={count}
              page={page}
              perPage={limit}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default memo(OrdersTableComponent);
